"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QmsMapper = void 0;
const mapper_1 = require("./mapper");
const forumMapper_1 = require("./forumMapper");
class QmsMapper {
    static mapDialogs(data) {
        // Data is wrapped in an array: [[dialogs]]
        return mapper_1.PdaMapper.mapList(data[0], this.QmsUserSchema);
    }
    static mapThreads(data) {
        if (!data || !data[0])
            return [];
        let userItem = data[0];
        // Если данные обернуты еще в один массив (двойная обертка), извлекаем вложенный
        if (Array.isArray(userItem) && Array.isArray(userItem[0])) {
            userItem = userItem[0];
        }
        // Темы диалога лежат на индексе 7 в параметрах пользователя
        const threads = Array.isArray(userItem) ? userItem[7] : null;
        if (!Array.isArray(threads))
            return [];
        return mapper_1.PdaMapper.mapList(threads, this.QmsThreadSchema);
    }
    static mapChat(data) {
        // Flat array
        const chat = mapper_1.PdaMapper.map(data, this.QmsChatSchema);
        if (chat.messages && chat.messages.length > 0) {
            let num = chat.myUnreadCount || 0;
            // Mark outgoing messages as unread from the end, matching the Android client logic
            for (let i = chat.messages.length - 1; i >= 0; i--) {
                const msg = chat.messages[i];
                if (msg.authorId !== chat.partnerId) {
                    msg.unread = (num > 0);
                    num--;
                }
            }
        }
        return chat;
    }
    static mapBlacklist(data) {
        // Data: [[items]]
        return mapper_1.PdaMapper.mapList(data[0], this.BlacklistSchema);
    }
}
exports.QmsMapper = QmsMapper;
QmsMapper.QmsThreadSchema = {
    id: 0,
    date: 1,
    lastDate: 2,
    title: 3,
    count: 4,
    unread: 5,
    lastMsgId: 6
};
QmsMapper.QmsUserSchema = {
    id: 0,
    name: 1,
    userGroup: 2,
    avatar: 3,
    lastVisit: 4,
    ts: 5,
    unreadCount: 6,
    threads: { index: 7, list: QmsMapper.QmsThreadSchema }
};
QmsMapper.QmsMessageSchema = {
    id: 0,
    authorId: 1,
    date: 2,
    text: 3,
    attachments: { index: 4, map: (v) => forumMapper_1.ForumMapper.mapPostAttachments(v) },
};
QmsMapper.QmsChatSchema = {
    threadId: 0,
    startTs: 1,
    lastTs: 2,
    title: 3,
    partnerId: 4,
    partnerName: 5,
    partnerGroup: 6,
    partnerAvatar: 7,
    partnerLastVisit: 8,
    count: 9,
    unread: 10,
    lastMsgId: 11,
    myUnreadCount: 12,
    messages: { index: 13, list: QmsMapper.QmsMessageSchema }
};
QmsMapper.BlacklistSchema = {
    id: 0,
    name: 1,
    avatar: 2
};
